import { useState, type FormEvent } from "react";
import { X, Upload } from "lucide-react";
import "@/components/ui/Modal.css";

export function CreateServerModal({ onClose }: { onClose: () => void }) {
  const [name, setName] = useState("");
  const [isPublic, setIsPublic] = useState(true);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    onClose();
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal--sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal__header">
          <h2 className="modal__title">create server</h2>
          <button className="modal__close" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal__content">
            <div className="settings-panel">
              <div className="settings-panel__section">
                <label className="settings-panel__label">server icon</label>
                <div className="create-server__icon-area">
                  <Upload size={24} />
                </div>
              </div>

              <div className="settings-panel__section">
                <label className="settings-panel__label">server name</label>
                <input
                  className="settings-panel__input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="my new server"
                  autoFocus
                />
              </div>

              <div className="settings-panel__toggle-row">
                <span>public server</span>
                <button
                  type="button"
                  className={`toggle-switch${isPublic ? " toggle-switch--on" : ""}`}
                  onClick={() => setIsPublic(!isPublic)}
                >
                  <div className="toggle-switch__knob" />
                </button>
              </div>
            </div>
          </div>

          <div className="modal__footer">
            <button
              type="button"
              className="settings-panel__outline-btn"
              onClick={onClose}
            >
              cancel
            </button>
            <button
              type="submit"
              className="settings-panel__save"
              disabled={!name.trim()}
            >
              create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
